import { officeEntityModalConstants as C } from "./constants";

export const openOfficeEntityModal = ({
    type,
    entityId,
    officeId,
    source = "",
    sourceTitle = "",
    payload = null,
} = {}) => ({
    type: C.OFFICE_ENTITY_MODAL_OPEN,
    payload: {
        type,
        entityId,
        officeId,
        source,
        sourceTitle,
        payload,
        openedAt: Date.now(),
    },
});

export const closeOfficeEntityModal = () => ({
    type: C.OFFICE_ENTITY_MODAL_CLOSE,
});
